module.exports = __webpack_public_path__ + "img/black_logo_pdf.1064774f.png";